import { GetUnauthenticatedAppointmentSlotsResponse } from './getUnauthenticatedAppointmentSlotsResponse';
import { incrementDate } from '../../../utils';

const slotList = new Array(4).fill(undefined).map((item, index) => ({
  appointmentDateTime: new Date(2024, 4, 31, 10, 0),
  daysToAppointment: '',
  slotId: `slot${index}`,
}));

const locationGroupList = new Array(2).fill(undefined).map((item, index) => ({
  locationId: `location${index}`,
  locationName: `Location ${index}`,
  slotList: slotList,
  timeZone: 'Central Time (CT)',
}));

const availableAppointmentSlots = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    appointmentDate: incrementDate(new Date(), 15 + index),
    locationGroupList: locationGroupList,
  }));

const providerLocations = new Array(2).fill(undefined).map((item, index) => ({
  locationId: `location${index}`,
  locationName: `Location ${index}`,
}));

const alternateProviders = new Array(4).fill(undefined).map((item, index) => ({
  daysUntilNextAppt: '15',
  provider: {
    id: `pid${index}`,
    name: `Provider Name ${index}`,
    providerNumber: `${index}`,
  },
  providerLocations: providerLocations,
  availableAppointmentSlots: availableAppointmentSlots,
}));

const mockData = {
  availableAppointmentSlots: availableAppointmentSlots,
  alternateProviders: alternateProviders,
};

export const GetUnauthenticatedAppointmentSlotsServiceMock: GetUnauthenticatedAppointmentSlotsResponse =
  {
    data: mockData,
    succeeded: true,
  };
